import {
  Item as SemanticItem,
  Image,
} from 'semantic-ui-react';

import ClampLines from 'react-clamp-lines';
import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import ProgressLayoutComponent from '../../../core/layout-components/progress';
import SidebarLayoutComponent from '../../../core/layout-components/sidebar';

const Sidebar = styled(SidebarLayoutComponent)`
  &.ui.sidebar {
    width: 200px;
  }
`;

const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 55px;
  justify-content: center;
  margin-bottom: 45px;
`;

const Logo = styled(Image)`
  &&& {
    display: inline;
    max-width: 150px;
  }
`;

const HeaderContainer = styled.div`
  align-items: center;
  flex: 1;
`;

const TypeProject = styled(SemanticItem)`
  flex-direction: row;
  margin: 0 0 45px 22px;
  max-width: 160px;
`;

const Title = styled(ClampLines)`
  color: ${(props) => props.theme.color.sidebarTitle};
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 1px;
  word-wrap: break-word;
`;

const TestType = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.sidebarTestType};
`;

const ProgressContainer = styled.div`
  align-content: flex-start;
  align-items: flex-start;
  border: solid 1px white;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin: auto;
  width: 80%;
`;

const Progress = styled(ProgressLayoutComponent)`
  &.ui.progress {
    margin-bottom: 8px;
  }
`;

const ProgressLabel = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.progress};
  text-transform: capitalize;
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 35px 0 0 0;

  & :hover {
    cursor: pointer;
  }
`;

export {
  HeaderContainer,
  ItemsContainer,
  Logo,
  LogoContainer,
  Progress,
  ProgressContainer,
  ProgressLabel,
  Sidebar,
  TestType,
  Title,
  TypeProject,
};
